module.exports = require('./helpers/bundle-url').getBundleURL('bccYT') + "logo-dark.ba5147f0.svg";